/* eslint-disable max-len */
const lang = {
    common: {
        fetching: 'Atractivo...',
        refresh: 'Actualizar',
        refresh_success: 'Éxito al actualizar',
        refreshed: 'Refrescado',
        rewards_placeholder_title: 'No hay recompensas disponibles',
        rewards_placeholder_subtitle: 'No tienes ninguna recompensa disponible en este momento; actualiza o vuelve a verificar más tarde.',
        offers_placeholder_title: 'No hay ofertas disponibles',
        offers_placeholder_subtitle: 'No tiene ninguna oferta en este momento, actualice o verifique nuevamente más tarde',
        milestones_placeholder_title: 'No hay hitos disponibles',
        milestones_placeholder_subtitle: 'No tienes ningún hito para desbloquear en este momento; actualiza o vuelve a verificar más tarde.',
        messages_placeholder_title: 'No hay mensajes nuevos',
        messages_placeholder_subtitle: 'No tienes ningún mensaje nuevo en este momento, actualiza o vuelve a verificar más tarde.',
        purchases_placeholder_title: 'Sin historial de compras',
        purchases_placeholder_subtitle: '¡Vuelve a comprobarlo después de tu próximo viaje de compras! o haga clic en actualizar',
        redemptions_placeholder_title: 'Sin historial de canje',
        redemptions_placeholder_subtitle: '¡Comprueba nuevamente después de tu primer canje! o haga clic en actualizar'
    },
    validation: {
        email_required: 'el correo electrónico es obligatorio',
        email_invalid: 'formato de correo electrónico inválido',
        code_required: 'el código es obligatorio',
        code_invalid: 'formato de código inválido',
        name_required: 'el nombre es obligatorio',
        name_long: 'el nombre es demasiado largo',
        name_invalid: 'formato de nombre inválido',
        number_required: 'el número de tarjeta es obligatorio',
        number_short: 'el número de tarjeta es demasiado corto',
        number_long: 'el número de tarjeta es demasiado largo',
        number_invalid: 'formato de número de tarjeta inválido',
        zip_required: 'el código postal es obligatorio',
        zip_invalid: 'formato de código postal inválido',
        cvv_required: 'el CVV es obligatorio',
        cvv_invalid: 'formato de CVV inválido',
        expiry_required: 'la fecha de expiración es obligatoria',
        expiry_invalid: 'fecha inválida',
    },
    auth: {
        ten_dlc: {
            four_pin: {
                title: 'Bienvenido a {0}!',
                description: 'Haz clic en el botón para recibir tu código de verificación.',
            },
            six_pin: {
                title: 'Bienvenido a {0}!',
                description: 'Haz clic en el botón para recibir el código de verificación.',
            },
            birthday: {
                label: 'cumpleaños',
                title: 'Por favor, confirma tu fecha de nacimiento.',
                description: 'Selecciona tu fecha de nacimiento a continuación para continuar.',
                error: 'La fecha de nacimiento que seleccionaste no coincide con la registrada en tu perfil. Por favor, inténtalo de nuevo.',
                confirm: 'Confirmar cumpleaños',
            },
            welcome: {
                title: 'Bienvenido, {0}',
                title_anonymous: 'Bienvenido',
                description: 'Tu mensaje está a solo un clic de distancia.',
                description_two: 'Mantente actualizado y no te pierdas ninguna notificación importante.',
            },
            create: {
                title: 'Crea tu código PIN.',
                description: 'Para mejorar tu seguridad, por favor crea un código PIN de 4 dígitos. Usarás este PIN para futuros inicios de sesión.',
                create_pin: 'Crea un PIN.',
                confirm_pin: 'Confirma el PIN.',
                submit_pin: 'Enviar',
            },
            login: {
                title: 'Iniciar sesión',
                description: '¡Bienvenido de nuevo! Por favor, ingresa tu código PIN de 4 dígitos para acceder a tus mensajes.',
                enter_pin: 'Ingresa el PIN.',
                submit_pin: 'Iniciar sesión',
                forgot_pin: '¿Olvidaste tu PIN?',
                send_pin: 'Envíame mi PIN.',
            },
            enter_code: 'Ingresa el código.',
            forgot_code: '¿Olvidaste tu código?',
            view_message: 'Ver mensaje',
            see_menu: 'Ver menú',
            dismiss: 'Cerrar',
        },
        validation: {
            phone_number_required: 'El número de teléfono es obligatorio',
            pin_required: 'Se requiere PIN',
            pin_pattern: 'El pin debe tener al menos 4 caracteres',
            email_required: 'El correo electrónico es obligatorio',
            email_pattern: 'Correo electrónico no válido',
            password_required: 'Se requiere contraseña',
            password_pattern: 'La contraseña debe tener al menos 8 caracteres y 1 letra, 1 número y 1 puntuación',
            confirm_required: 'Se requiere confirmación',
            confirm_validate: 'La contraseña debe coincidir',
            shared_pin_paragraph: 'Ingrese su código de inicio de sesión a continuación para continuar',
            forgot_code: '¿Olvidó el código?',
            send_me_my_login_code: 'Envíame mi código de inicio de sesión'
        },
        links: {
            register: '¿Necesita una cuenta?',
            forgot: '¿Olvidó su contraseña?',
            login: '¿Ya tiene una cuenta?'
        },
        confirm_account: {
            error_title: '¡Oh, no!',
            error_paragraph: 'Hubo un error con su enlace de confirmación. Por favor revisa tu correo electrónico y vuelve a intentarlo.',
            confirmed_title: '¡Cuenta confirmada!',
            confirmed_paragraph: '¡Ahora puede iniciar sesión con su correo electrónico y comenzar a configurar su negocio!',
            confirming: 'Confirmando Cuenta...'
        },
        forgot_password: {
            success_title: '¡Éxito!',
            success_paragraph: 'Revise su correo electrónico para obtener un enlace de restablecimiento de contraseña.',
            title: 'Olvidé mi contraseña'
        },
        reset_password: {
            validating_token: 'Validando token...',
            invalid_link: 'Enlace de restablecimiento de contraseña no válido...',
            success_title: '¡Éxito!',
            success_paragraph: 'Ahora puede iniciar sesión con su nueva contraseña.',
            title: 'Restablecer contraseña',
        },
        login: {
            title: '¡Hola, <br/>bienvenido de nuevo!',
            paragraph: 'Ingrese su número de teléfono',
            success: 'Inicio de sesión exitoso!',
            pin_paragraph: 'Se ha enviado un PIN temporal a su teléfono y correo electrónico (si corresponde); ingréselo a continuación para continuar'
        },
        location: {
            what_state: '¿En qué estado de EE. UU. te encuentras?',
            choose_state: 'Por favor seleccione un estado',
            cannot_continue: 'No se puede continuar',
            merchant_does_not_serve: '¡Lo siento! Este comerciante no está autorizado para brindar servicios en su estado en particular.',
            location_associated_paragraph: 'Seleccione su comercio a continuación para continuar',
            location_unassociated_paragraph: '¿Viajando? Haga clic a continuación para registrarse en nuestros otros programas estatales.'
        },
        logout: '¡Has cerrado la sesión!',
        register: {
            title: '¡Bienvenido a {0}!',
            paragraph: 'Al proporcionar su número de teléfono y marcar la casilla proporcionada, acepta recibir llamadas y mensajes de texto enfocados en marketing, incluso a través de un sistema de marcación telefónica automática o voz pregrabada o artificial de {0} y sus afiliados, marcas y fabricantes de productos. No se requiere el consentimiento como condición para comprar bienes o servicios. Se pueden aplicar tarifas estándar de llamadas y mensajes por minuto. Opte por no participar en cualquier momento respondiendo "END".'
        },
        update_password: {
            title: 'Actualizar contraseña',
            paragraph: 'Se ha establecido una contraseña temporal en su cuenta. Por razones de seguridad, no puede continuar hasta que establezca una nueva contraseña. Establezca su nueva contraseña y podrá volver a iniciar sesión.'
        },
        geofence: {
            title: 'Restricción geográfica',
            default_subtitle: 'Debido a la política de la tienda de aplicaciones, esta app solo puede usarse en los estados/provincias donde están ubicadas nuestras tiendas. Comparte tu ubicación para continuar.',
            out_of_state_subtitle: 'Lo sentimos. No ofrecemos servicios en tu área ({0}, {1} - {2}). Debido a la política de la tienda de aplicaciones, no podrás acceder a la app hasta que estés en el mismo estado/provincia que nuestras tiendas.',
            out_of_state_manually_subtitle: 'Lo sentimos. No ofrecemos servicios en tu área ({0}, {1} - {2}). Por favor, selecciona tu estado manualmente si crees que esto es un error.',
            blocked_or_denied_subtitle: 'Se requieren permisos de ubicación para continuar.',
            grant_permissions: 'Conceder permisos'
        }
    },
    alerts: {
        loyalty_opt_in: 'Optar por la lealtad',
        loyalty_opt_in_message: 'Actualmente no está registrado en nuestro programa de recompensas al proporcionar su firma a continuación y hacer clic en "aceptar", ahora será elegible para ganar puntos de fidelidad y canjear recompensas.',
        text_opt_in: 'Espera',
        text_opt_in_message: 'No te registraste para recibir mensajes de texto sobre especiales, promociones y ofertas. Regrese y marque la casilla de verificación en los términos y condiciones para inscribirse en mensajes de texto.',
        text_opt_in_message2: 'Estás seguro de que quieres unirte sin saber acerca de especiales, promociones y ofertas?',
        hipaa_opt_in_message: 'Se requiere la siguiente información para completar el registro... marque la casilla de HIPAA',
        meta_message: 'Se requiere la siguiente información para completar el registro...',
        interest_auto_connect: 'Por favor, haz clic en tus intereses para activar la oferta.',
    },
    rewards: {
        title: 'Recompensas',
        modal_title: 'Canjear recompensa',
        title_points_rewards: '{0} puntos de recompensa',
        points_redeemable: 'Puntos canjeables',
        spend_toward_status: 'Gastar hacia el estado',
        redemption_text: '¡ALTO! Asegúrese de estar con el personal antes de canjear su recompensa. El personal debe ver cómo canjeas tu oferta para que puedas recibir tu recompensa.\n¿Estás listo para canjear tu recompensa?: {0}',
        redemption_modal_title: 'Canje de recompensas',
        redemption_in_store: '¡Estoy tan emocionado de querer canjear sus puntos! ¡Canjee sus puntos en la tienda y antes de pagar!',
        available_points: 'puntos disponibles',
        click_here_to_earn: 'haga clic aquí para comenzar a ganar puntos',
        expires_at: 'caduca {0}',
        return_to: 'volver a {0}',
    },
    redeem: {
        at: 'Canjeado en: {0}',
        valid_until: 'Válido hasta {0}',
        confirmation: 'Confirmación: {0}',
        confirmation_number: 'Confirmación: {0}',
        go_back: 'regresar a la billetera',
        expired: '¡Expirado!',
        expires: 'Expira',
        redeemed: 'Canjeado',
        redeemed_at: 'Canjeado en: {0}',
        back: 'Volver a la billetera',
        with_staff: 'Estoy con el personal: proceder a las {0}',
        points_needed: 'necesitas ',
        to_redeem: ' para canjear {0}',
        point: 'punto',
    },
    offers: {
        title: 'Ofertas',
        title_refer: 'Recomendar a un amigo',
        modal_title: 'Canjear oferta',
        available_offers: 'Ofertas disponibles',
        refer_friend: 'Recomendar a un amigo',
        redemption_text: '¡ALTO! Asegúrese de estar con el personal antes de canjear su recompensa. El personal debe ver cómo canjeas tu oferta para que puedas recibir tu recompensa.\n¿Estás listo para canjear tu recompensa?: {0}',
        redemption_modal_title: 'Canje de recompensas',
        redemption_in_store: '¡Tan emocionado que desea canjear su oferta! ¡Canjee su oferta en la tienda y antes de pagar!',
        unlock: 'Desbloquear esta oferta',
        add: 'Agregar',
        add_birthday: 'Agregar cumpleaños',
        free_pre_roll: '+ pre-roll gratis',
        desirable_action: 'Actualiza tu {0} para ganar {1}',
        no_offers: 'No hay ofertas disponibles',
        quantity: 'usar {0}x',
    },
    milestones: {
        title: 'Hitos',
        spends_remaining: 'gastar ${0} más para desbloquear este hito',
        spends_title: 'Gasta ${0} para ganar {1}',
        points_remaining: 'Gasta {0} más para desbloquear {1}',
        points_title: 'Gasta {0} en {1} para ganar {2}',
        benefits_title: 'Los beneficios incluyen:',
        milestone_achieved: '¡meta alcanzada!',
        congratulations: '¡Felicidades! Has alcanzado {0}',
        achieved: '{0} alcanzado!'
    },
    subscriptions: {
        no_plan_message: 'No hay planes premium disponibles',
        title: 'Suscripciones',
        get: 'Suscribirse',
        enjoying: 'Gestionar plan',
        active_section: 'Planes activos',
        explore_section: 'Explorar planes',
        back_button: 'Volver a la billetera',
        benefits: 'Los beneficios incluyen',
        cancellation_warning: '¿Estás seguro de que deseas cancelar tu suscripción?',
        cancellation_disclaimer: 'Al hacerlo, conservarás tus beneficios durante el resto de tu período actual de suscripción.',
        free_trial: 'Los primeros {0} dias son por nuestra cuenta, luego de eso es solo ',
        free_then: '{0} dias gratis, luego ',
        active_until: 'Activo hasta {0}',
        renews_on: 'El plan se renueva el {0}',
        update_email_info: 'Actualiza tu información de correo electrónico',
        billing: {
            both: '${0} al mes o ${1} al año',
            monthly: '${0} al mes',
            yearly: '${0} al año',
        },
        previously_used: 'usado previamente',
        pricing_title: 'Precios',
        pricing: ', puedes cancelar en cualquier momento',
        terms_prefix: 'He leído y acepto los ',
        terms_suffix: 'términos y condiciones*',
        terms_error: 'Necesitas aceptar los términos y condiciones',
        next: 'Siguente (2 de 2)',
        email_field: 'correo electrónico',
        email_verification: '¡Verifica tu correo electrónico para recibir ofertas exclusivas!',
        email_error: 'Hubo un problema con tu solicitud: {0}. Si el problema persiste, por favor contacta a un administrador',
        details: {
            title: '¡Desbloquea beneficios premium ahora!',
            description: 'Actualiza a nuestro plan premium ahora y ve cómo crecen tus ahorros. ¡No te pierdas los beneficios exclusivos y recompensas inigualables!',
            try_button: 'Continuar',
            try_free_button: '¡Pruébalo gratis!',
        },
        code_sent: 'se ha enviado un código a tu bandeja de entrada de correo electrónico',
        code_field: 'código',
        code_resend: 'reenviar código',
        change_email: 'cambiar correo electrónico',
        verify_email: 'Verificar correo electrónico',
        manage: {
            title: 'Gestionar {0}',
            update_email: 'Actualizar correo electrónico',
            change_card: 'Cambiar tarjeta',
            cancel_subscription: 'Cancelar suscripción',
        },
        success: {
            title: '¡Bienvenido a {0}!',
            description: 'Te has suscrito con éxito a nuestro {0}',
            description_two: '¡Mantente atento a ofertas y promociones exclusivas!',
            view_offers_button: 'Ver ofertas',
        },
        popups: {
            failed_payment: {
                title: 'Pago fallido',
                text: 'Para mantener el plan premium, actualiza tu método de pago lo antes posible',
                button: 'Actualizar',
            },
            sub_prompt: {
                title: 'Únete a nuestro club VIP para ofertas exclusivas',
                button: 'Haz clic aquí para saber más',
                dismiss: 'No me lo recuerdes',
            },
        }
    },
    credit_card: {
        add_payment: 'agregar pago',
        choose_plan: 'Elige tu plan',
        monthly_title: 'Mensual',
        monthly_price: '${0}/mes',
        monthly_summary: 'Paga ${0} al mes. Cancela en cualquier momento.',
        yearly_title: 'Anual',
        yearly_price: '${0}/año',
        yearly_summary: 'Paga ${0} al año. Cancela en cualquier momento.',
        free_trial: 'Prueba gratuita de {0} días',
        add_card: 'Agregar información de tarjeta',
        name: 'nombre del titular de la tarjeta',
        number: 'número de tarjeta',
        cvv: 'CVV',
        expiry: 'fecha de expiración',
        zip_code: 'código postal',
        subscribe_button: 'Suscribirse',
        cancel_button: 'Cancelar',
        disclaimer: 'Al agregar esta tarjeta, confirmas que eres el titular de la tarjeta o que tienes autorización para usar este método de pago.'
    },
    profile: {
        title: 'Perfil',
        my_account: 'Mi Cuenta',
        phone: 'Mi teléfono:',
        email: 'Mi email:',
        birthday: 'Mi cumpleaños:',
        greetings: 'Hola, {0}',
        spend_toward_status: '{0} Gastar en el estado',
        upload_profile: 'Subir imagen de perfil',
        choose_from_library: 'Choose from library',
        take_photo: 'Elige de la biblioteca',
        cancel: 'Cancelar',
        edit: 'editar',
        remove_photo: 'Quitar foto',
        profile_image_added: 'Imagen de perfil agregada.',
        profile_image_removed: 'Imagen de perfil eliminada.',
        profile_updated: '¡Perfil actualizado con éxito!',
        undo: 'deshacer'
    },
    profileMenu: {
        my_information: 'Informacion personal',
        recent_history: 'Historial',
        message_notifications: 'Configuración de notificaciones',
        terms_condition: 'Términos y condiciones',
        privacy_policy: 'Política de privacidad',
    },
    accountInformation: {
        delete_account_title: '¿Está seguro de que desea eliminar su cuenta?',
        delete_account_message: `al hacerlo, todos los puntos de fidelidad ganados se eliminarán y no estarán disponibles para su uso y se cancelará la recepción de todos los mensajes de este minorista.

    Una vez que elimine su cuenta, será permanente y no se podrá deshacer.`,
        delete_account: 'Eliminar cuenta',
        delete_account_header_title: 'Se ha enviado un código pin temporal a su teléfono. Introdúzcalo a continuación para confirmar que desea eliminar su cuenta.'
    },
    refer: {
        title: 'Recomendar a un amigo',
        copy_link: 'Copiar enlace',
        link_copied: 'Enlace Copiado',
        text_prize: 'Cuando uno de tus amigos se una, en tu referencia, recibirás un',
        text_prize_purchase: 'Cuando uno de tus amigos compre, en tu referencia, recibirás un',
        prize: '30% de descuento en una compra',
        text_receiver: 'y recibirán',
        pre_rolled_reward: 'un pre-roll gratis',
        text_link: 'Copia y comparte el siguiente enlace con tus amigos o muéstrales a tus amigos tu código qr único arriba para que se registren fácilmente.',
        text_social_media: '¡No olvides compartir tu enlace en las redes sociales!'
    },
    interests: {
        title: 'Intereses'
    },
    messages: {
        title: 'Centro de mensajes',
        no_messages: 'No hay mensajes',
        shop_now: 'Comprar ahora',
    },
    anylink: {
        view_more: 'Ver más',
        view_offers: 'Ver ofertas',
        view_rewards: 'Ver recompensas',
        view_profile: 'Ver perfil',
        view_info: 'Ver mi información',
        view_interests: 'Ver intereses',
        view_refer: 'Ver enlace de referido',
        shop_online: 'Comprar online',
        view_gift_card: 'Ver {0}',
    },
    settings: {
        header_title: 'Configuración de comunicación',
        communication_preferences: 'Preferencias de comunicación',
        my_preferred: 'Mi comunicación preferida es ',
        modal_title: 'Suscribirse al marketing por correo electrónico',
        modal_paragraph: 'acepto los términos y firma a continuación para optar por la mensajería',
        modal_terms_and_conditions: 'Al marcar esta casilla, acepto recibir mensajes de marketing automatizados de {0} y sus afiliados, marcas y fabricantes de productos. El consentimiento no es una condición para comprar bienes o servicios',
        sms_opt_in_disclaimer: 'Al seleccionar esta casilla, doy mi consentimiento para recibir llamadas informativas y de marketing, así como mensajes de texto de {0} y sus subsidiarias, incluidos los enviados por medios automáticos o pregrabados, al número proporcionado. El consentimiento no es una condición de compra. Responde STOP para darte de baja. Pueden aplicarse tarifas de mensajes y datos. Consulta los términos y la política de privacidad para obtener más información.',
        email_opt_in_disclaimer: 'Al seleccionar esta casilla, doy mi consentimiento para recibir correos electrónicos informativos y de marketing de {0} y sus afiliados, incluidos los enviados por medios automáticos o pregrabados, a la dirección de correo electrónico proporcionada. El consentimiento no es una condición de compra. Consulta los términos y la política de privacidad para obtener más información.',
        loyalty_opt_in_disclaimer: '',
        text_message: 'Mensajes de texto',
        push_notifications: 'Notificaciones push',
        email_notifications: 'Notificaciones por correo electrónico',
    },
    history: {
        title_purchases: 'Compras',
        title_redemptions: 'Redenciones',
        transaction_total: 'Total de la transacción',
        item_ordered: 'Artículos pedidos',
        category: 'Categoría',
        brand: 'Marca',
        product_name: 'Nombre del producto',
        redeemed: 'redimido',
        points: 'puntos',
    },
    general: {
        accept: 'Aceptar',
        address1: 'Dirección 1',
        address2: 'Dirección 2',
        back: 'atras',
        birthday: 'Cumpleaños',
        cancel: 'Cancelar',
        cart: 'Carrito',
        city: 'Ciudad',
        confirm_password: 'Confirmar contraseña',
        continue: 'Continuar',
        delete: 'Eliminar',
        edit: 'Editar',
        email: 'Correo electrónico',
        female: 'mujer',
        first_name: 'Nombre',
        gender: 'Género',
        get: 'Obtener',
        use: 'Usar',
        unlimited: 'ilimitado',
        earning: 'Ganancia',
        go_back: 'Volver',
        last_name: 'Apellido',
        loading: 'Cargando',
        login: 'Iniciar sesión',
        male: 'masculino',
        merchant: 'Comerciante',
        messages: 'Centro de mensajes',
        new_password: 'Nueva contraseña',
        offers: 'Ofertas',
        old_password: 'Contraseña antigua',
        other: 'otro',
        password: 'Contraseña',
        phone_number: 'Número de teléfono',
        pin: 'Ingresar pin',
        press_to_sign: 'Presione para firmar',
        privacy_policy: 'Política de privacidad',
        profile: 'Perfil',
        redeemed: 'Redimido',
        region: 'Estado/Región',
        rewards: 'Recompensas',
        save: 'Guardar',
        select_date: 'Seleccionar fecha',
        sign_below: 'Por favor firme abajo',
        signature_saved: 'Firma guardada',
        signature: 'Firma',
        submit: 'enviar',
        success: 'Éxito',
        terms_and_conditions: 'Términos y condiciones',
        zip: 'Código postal/Código postal',
        select_language: 'Seleccionar idioma',
        preferred_method: 'Método de Comunicación Preferido',
        add: 'agregar',
        interest: 'interés',
        update: 'actualizar',
        updated: 'actualizado',
        email_example: 'john@gmail.com',
        how_did_you_hear_about_us: '¿Cómo te enteraste de nosotros?',
        favorite_location: 'Ubicación favorita',
        wallet_terms: 'Términos y condiciones',
        submitError: 'Hubo un problema al procesar tu solicitud, por favor intenta nuevamente más tarde',
        amount: 'cantidad',
        payment: 'pago',
        location: 'ubicación',
        points: 'puntos',
        send: 'enviar',
        enabled: 'habilitado',
        disabled: 'deshabilitado',
        download_app: 'Descargar',
    },
    errors: {
        invalid_email: 'Por favor, ingresa un correo electrónico válido',
        birthday_in_past: 'Por favor, selecciona una fecha en el pasado'
    },
    cart: {
        no_website: 'No hay sitio web disponible',
    },
    apiErrors: {
        postJoinPhone: 'Error al enviar el número de teléfono',
        getJoinPin: 'Error al enviar el pin',
        getWalletMember: 'Error al recibir la billetera',
        getWalletMilestones: 'Error al recibir hitos',
        postWalletRedemption: 'Error al canjear recompensas',
        getNativeMerchantOrgs: 'Error al recibir ubicaciones',
        getNativeAppStashboardKeys: 'Error al recibir las claves del mensaje',
        getNativeAppStashboard: 'Error al recibir la información del mensaje',
        getNativeAppRewardRedemption: 'Error al canjear recompensas',
        getNativeAppVisit: 'Error al recibir la visita',
        putNativeAppSync: 'Error al sincronizar',
        patchNativeAppUpdate: 'Error al actualizar su miembro',
        postNativeAppCreate: 'Error al crear su miembro',
    },
    navigation: {
        menu: 'Menu',
        cart: 'Carrito',
        messages: 'Mensajes',
        profile: 'Perfil',
        rewards: 'Recompensas',
        offers: 'Ofertas',
        refer: 'Referir',
        milestones: 'Hitos',
        subscriptions: 'Suscripciones',
        select_store: 'Seleccionar tienda',
        springbigpay: 'Pagar',
        accountHistory: 'Historial de compras',
        premium: 'Premium',
        home: 'Inicio',
    },
    giftCard: {
        field: {
            amount: 'monto',
            method: 'método de pago',
            loyalty: 'seleccionar tarjeta de fidelidad',
        },
        manage: {
            success: 'información de pago eliminada con éxito',
            error: 'hubo un error al eliminar su información de pago, por favor contacte a un administrador',
        },
        more_info: 'más información',
        fund_with_points: 'cargar {0} con puntos',
        points_for: 'puntos por',
        select_card: 'seleccionar {0}',
        add_cc: 'Agregar crédito/débito',
        cards: 'tarjetas',
        plus_payment: '+ pago',
        other: 'otro',
        manage_funds: 'administrar fondos',
        reloadable: 'recargable',
        non_reloadable: 'no-recargable',
        on: 'activado',
        off: 'desactivado',
        locations: 'ubicaciones',
        used_at: 'se puede usar en:',
        no_access: 'sin accesso',
        claimBefore: 'reclama antes de {0}',
        claimNow: 'Reclamar ahora',
        claim: 'Reclamar',
        claiming: 'reclamando...',
        claimEmailVerifyHeader: 'Por favor, verifica tu correo electrónico para reclamar tu {0}',
        claimSuccess: '¡{0} reclamado!',
        bannerHeading: 'Nuevos {0}s te están esperando',
        inboxHeading: '{0}s disponibles',
        inboxEmailNotValidatedHeading: 'Verifica tu correo electrónico para reclamar tus {0}s',
        inboxGrantsAvailable: 'Tienes {0}s sin reclamar que requieren tu atención.',
        claimBeforeExpiration: '¡Reclámalos antes de que expiren!',
        claimExtraNote: 'Nota: los {0}s deben ser reclamados para ser emitidos a tu cuenta.',
        inboxGrantsClaimed: '{0}s añadidos a tu cartera',
        balanceUpdated: '¡Tu saldo de {0} ha sido actualizado!',
        description: '{0} {1}',
        addedOn: 'añadido {0}',
        navigateTo: 'Ir a {0}s',
        balanceAddedHeading: '¡{0} añadido a tu saldo de {1}!',
        inboxSendCodeButton: 'Enviar código',
        inboxBannerHeading: 'Nuevos {0}s te están esperando',
        inboxBannerSubHeading: 'Tienes actividad de {0} en tu cuenta',
        inboxBannerButton: 'Revisar ahora',
        totalCards: 'tarjetas totales',
        noCards: 'no hay tarjetas disponibles',
        addCash: 'agregar fondos en efectivo',
        pinCode: 'código PIN: {0}',
        sendToFriend: 'enviar un {0} a un amigo',
        importExistingButton: 'importar {0} existente',
        emailVerificationTitle: 'Por favor, verifica tu correo electrónico. ¡Esto ayuda a mantener las cosas seguras!',
        nameCompletionFormTitle: 'Completa tu perfil para continuar',
        primary: {
            title: 'tarjeta principal',
            button: 'hacer principal'
        },
        barcode: {
            view: 'ver código de barras'
        },
        update: {
            success: 'tarjeta actualizada exitosamente',
            error: 'hubo un problema al actualizar esta tarjeta como tarjeta principal, por favor intenta nuevamente más tarde.'
        },
        balance: {
            manage_cash: 'administrar efectivo',
            cash_balance: 'saldo en efectivo',
            point_balance: 'saldo de puntos',
            convert_points_cash: 'convertir puntos a efectivo'
        },
        autoReload: {
            updateStatus: 'Recarga automática'
        },
        addFunds: {
            fundWithPoints: 'fundar {0} con puntos',
            reloadSuccess: 'tarjeta recargada exitosamente',
            createSuccess: 'tu tarjeta fue creada y cargada exitosamente',
            title: 'agregar fondos',
            autoReload: {
                title: 'configuración de recarga automática',
                subTitle: 'recarga automática',
                belowbalance: 'cuando el saldo esté por debajo de',
                amount: 'monto de carga',
                payment: 'método de pago'
            },
            conditions: {
                fees: '* se agregará una tarifa de procesamiento adicional de {0}'
            }
        },
        addPayment: {
            addBank: {
                caption: 'conectar cuenta bancaria',
                form: {
                    name: {
                        title: 'nombre de la cuenta bancaria *',
                        error: 'el número de cuenta es obligatorio y debe estar en formato válido'
                    },
                    number: {
                        title: 'número de cuenta *',
                        error: 'el nombre de la cuenta bancaria es obligatorio'
                    },
                    routingNumber: {
                        title: 'número de ruta *',
                        error: 'el número de ruta es obligatorio y debe estar en formato válido'
                    }
                }
            },
            addCard: {
                caption: 'tarjeta de crédito/débito',
                form: {
                    name: {
                        title: 'nombre en la tarjeta *',
                        error: 'el nombre en la tarjeta es obligatorio y no debe contener caracteres especiales ni números'
                    },
                    number: {
                        title: 'número de tarjeta *',
                        error: 'el número de tarjeta es obligatorio y debe tener entre 14 y 19 dígitos'
                    },
                    cvv: {
                        title: 'cvv *',
                        error: 'el cvv es obligatorio y debe tener 3 dígitos'
                    },
                    expiryDate: {
                        title: 'fecha de vencimiento *',
                        error: 'la fecha de vencimiento es obligatoria y debe estar en formato mm/aa'
                    },
                    zip: {
                        title: 'código postal *',
                        error: 'el código postal es obligatorio y debe ser una mezcla de 6 letras o números'
                    }
                }
            }
        },
        restrictions: {
            points_limit: 'Tu umbral de recarga individual actual para este período es {0} y hasta {1} en total',
            cash_limit: 'Tu umbral de recarga individual actual para este período es ${0} y hasta ${1} en total',
            one_time_point_limit_under: 'Tu umbral de recarga para este período es {0} de {1}',
            one_time_dollar_limit_under: 'Tu umbral de recarga para este período es ${0} de ${1}',
            one_time_point_limit_over: 'Tu umbral de recarga individual para este período es {0}. Tu recarga total restante para este período es {1} de {2}',
            one_time_dollar_limit_over: 'Tu umbral de recarga individual para este período es ${0}. Tu recarga total restante para este período es ${1} de ${2}',
            information: {
                cash_title: 'Pagos con tarjeta:',
                cash_one_time: 'Tu monto máximo de recarga individual es ${0}',
                cash_per_period: 'Tu monto máximo total es ${0}',
                cash_period: 'Se recarga cada {0} días',
                points_title: 'Canje de puntos:',
                points_one_time: 'Tu máximo de conversión de puntos individual es {0}',
                points_per_period: 'Tu máximo de conversión total es {0}',
                points_period: 'Se recarga cada {0} días'
            }
        },
        pointsConvertor: {
            title: 'convertir puntos a efectivo',
            notEnoughPoints: 'no tienes saldo suficiente',
            pointsFor: 'puntos para',
            reloadSuccess: 'tarjeta recargada exitosamente',
            selectRoyaltyError: 'por favor selecciona una tarjeta de lealtad para continuar',
            form: {
                accountNumber: {
                    placeholder: 'Número de cuenta'
                }
            }
        },
        send: {
            title: 'enviar {0} a un amigo',
            sent: {
                title: '{0} enviado!',
                amount: 'monto: ${0}',
                to: 'a: {0}'
            },
            form: {
                email: {
                    title: 'correo electrónico del amigo',
                    error: 'por favor ingresa una dirección de correo electrónico válida'
                }
            }
        },
        received: {
            disclaimer: 'has recibido un {0}!',
            title: 'nuevo {0} recibido',
            button: 'agregar a la billetera',
            from: 'de: {0}',
        },
        add: {
            title: 'agregar un {0}',
            uploadButton: 'subir {0} existente',
            fundButton: 'financiar tu nuevo {0}'
        },
        importExisting: {
            title: 'importar {0} existente',
            form: {
                number: {
                    title: '{0} número *',
                    error: 'el número de tarjeta es obligatorio y debe tener 19 dígitos'
                },
                pin: {
                    title: 'código PIN *',
                    error: 'el código PIN es obligatorio y debe tener 4 dígitos'
                }
            },
            currentBalance: 'saldo actual {0}',
            submitButton: 'agregar tarjeta a la billetera',
            error: 'hubo un problema al importar tu tarjeta, por favor intenta nuevamente más tarde',
            success: 'tu tarjeta fue importada exitosamente'
        },
        deleteCardsModal: {
            title: 'Limpiar',
            description: 'Al elegir esta opción, se eliminarán las tarjetas no usadas o aquellas con un saldo restante de 0',
            disclaimer: 'No puedes deshacer esta acción',
            backButton: 'Volver a la billetera',
            confirmButton: 'Limpiar billetera'
        },
        transactions: {
            title: 'historial de cargas de {0}',
            greeting: 'Hola, {0}',
            lastUpdated: 'última actualización {0}',
            noTransactions: 'No tienes historial de cargas',
            back: 'volver a la página de inicio',
            nextPage: 'siguiente página',
            prevPage: 'página anterior',
            total: 'total {0}',
            pageOf: 'página {0} de {1}',
            view_transaction: 'ver historial de carga',
            transaction_points: '{0} puntos',
            processing_fee: '+ {0} tarifa',
            card_load: 'carga de tarjeta',
            empty_state: 'No tienes historial de carga',
            details: {
                titleLoadAmount: 'Monto de carga',
                titleDate: 'Fecha',
                id: 'ID de transacción: {0}',
                date: 'fecha de transacción',
                status: 'estado de la transacción',
                type: 'tipo de transacción',
                nmi: 'pago con tarjeta',
                points_for_cash: 'conversión de puntos',
                offer_extension: 'extensión de oferta',
                referenceId: 'ID de referencia de la transacción',
                fee: 'tarifa de transacción',
                total: 'total de la transacción',
                currency: 'moneda de la transacción',
                last4digit: 'últimos 4 dígitos del pago',
                providerId: 'ID del proveedor de pago',
                loadAmount: 'monto de carga de la tarjeta',
                pointsRedeemed: 'puntos canjeados',
                giftCardDigits: 'últimos 4 dígitos de la tarjeta',
                reward: 'recompensa',
            }
        }
    },
    suspended_account: {
        disclaimer: 'Estimado cliente, apreciamos su lealtad. Estamos en el proceso de renovar nuestro acuerdo del programa de lealtad. Mientras trabajamos en los detalles de esta renovación, queríamos asegurarle que los puntos y recompensas que ha ganado con nosotros están 100% seguros. El acceso a su billetera de lealtad estará disponible tan pronto como sea posible. Nos disculpamos por cualquier inconveniente que esto pueda estar causando. No dude en ponerse en contacto con nuestro equipo en la tienda si tiene alguna pregunta y/o inquietud.'
    },
    shop: {
        title: 'Shop',
        filters: 'aplicar filtros',
        apply_filters: 'aplicar filtros',
        active_filters: 'Filtros activos',
        clear_filters: 'limpiar',
        between_price_filter: 'entre ${0} y ${1}',
        sort: 'ordenar por:',
        in: 'en',
        favorite_brands: 'marcas favoritas',
        search: 'Buscar',
        see_all: 'ver todo',
        cart_empty: 'tu carrito está vacío',
        apply: 'aplicar',
        oops: '¡Ups!',
        we_cant_find: 'No podemos encontrar tus pedidos anteriores.',
        add_your_email: 'Agrega tu correo electrónico aquí para ver tus pedidos anteriores',
        add_email: 'agregar correo electrónico',
        x: 'x',
        subtotal: 'subtotal:',
        fees: 'tarifas:',
        taxes: 'impuestos:',
        discounts: 'descuentos:',
        total: 'total:',
        back: 'regresar',
        order_number: 'número de pedido:',
        order_submitted: '¡Pedido enviado!',
        return_to_app: 'Volver a la aplicación',
        at: 'en',
        delivery: 'entrega',
        pickup: 'recogida',
        items: 'artículos',
        see_past_orders: 'ver pedidos pasados',
        go_to_checkout: 'ir a la caja',
        back_to_store: 'volver a la tienda',
        see_fulfillment_hours: 'ver horas de cumplimiento',
        some_fulfillment_options: '* algunas opciones de cumplimiento podrían no estar disponibles debido a las horas de pedido -',
        would_you_like_to_continue: '¿Te gustaría continuar?',
        due_to_differences: 'Debido a diferencias en inventarios y precios, al cambiar tu ubicación perderás todo el progreso del pedido.',
        directions: 'direcciones',
        call: 'llamar',
        view_cart: 'ver carrito',
        add_to_cart: 'agregar al carrito',
        add: 'agregar',
        thc: 'thc: ',
        cbd: 'cdb: ',
        add_item: 'agregar artículo',
        view_details: 'ver detalles',
        reorder: 'reordenar',
        item: 'artículo',
        s: 's',
        grant_permission: 'conceder permiso',
        grant_permission_info: 'se requieren permisos de ubicación para comprar en línea',
        your_orders: 'tus pedidos',
        pick_your_location: 'Elige tu ubicación',
        location_and_method: 'ubicación y método',
        no_matching_location: 'No se encontró ninguna tienda que coincida con tu parámetro de búsqueda',
        distance: 'Distancia',
        update_your_email: 'Actualiza tu información de correo electrónico',
        grant_location_permission: 'Conceder permiso de ubicación',
        location_permissions_are_required: 'Se requieren permisos de ubicación para comprar en línea',
        permissions_can_be_reset: 'Los permisos pueden restablecerse en tus preferencias o haciendo clic en el ícono en la barra de direcciones',
        alert: 'alerta'
    },
    payment: {
        manage: 'administrar',
        manage_payments: 'gestionar pagos',
        cards_on_file: 'tarjetas en el archivo',
        new_card: '+ nueva tarjeta',
        add: 'agregar',
        remove: 'eliminar',
        save: 'ahorrar',
    },
    home_page: {
        named_greetings: 'Hola, ',
        anonymous_greetings: '¡Hola!',
        edit: 'editar',
        save: 'guardar',
        view_more: 'ver más',
        filters: {
            total: 'total',
            week: 'últimos 7 días',
        },
        subscriptions: {
            title: 'suscripciones',
            benefits: 'Beneficios',
            see_benefits: 'ver beneficios',
        },
        gift_cards: {
            title: '{0}',
            manage_funds: 'gestionar fondos',
            view_all: 'ver todas las tarjetas',
            view_barcode: 'ver códigos de barras',
            card_balance: 'saldo de tarjeta ${0}',
            back: 'regresar',
        },
        milestones: {
            title: 'metas',
            spend_title: 'Metas de gasto',
            points_title: 'Metas de puntos',
        },
        referrals: {
            title: 'recomienda a un amigo',
            copy_link: 'copiar enlace',
            copied_link: 'enlace copiado',
            offers_earned: 'ofertas obtenidas',
            referred: 'recomendado',
        },
        messages: {
            title: 'mensajes',
            unread: 'no leídos',
            caught_up: '¡estás al día!',
            previous: 'ver anteriores',
        },
        rewards: {
            title: 'recompensas',
            earned: 'ganado',
            redeemed: 'redimido',
            highest: 'más alto disponible',
            get: 'obtener',
            value: '{0} puntos',
        },
        offers: {
            title: 'ofertas',
            earned: 'ganado',
            redeemed: 'redimido',
            latest: 'más reciente',
            get: 'obtener',
            expiration: 'vence {0}',
            redemptions: 'uso x{0}',
        },
        bonus_points: {
            title: 'puntos extra',
        },
        point_balance: {
            title: 'saldo de puntos',
            learn_more: 'aprende cómo ganar más puntos',
            total_points: 'puntos totales',
            last_earned: 'últimos ganados',
            bonus_points: {
                title: 'puntos extra',
                get: 'uso x{0}',
                unlimited: 'obtener',
                earning: 'ganando',
                earning_prefix_multiplication: 'gana x{0} puntos',
                earning_prefix_addition: 'gana {0} puntos',
                expiration: 'vence {0}',
            },
            and: 'y',
            or: 'o',
            bonus_rules: {
                day_of_the_week: 'los {0}',
                order_source: 'cuando ordenas {0}',
                transaction_location: 'cuando compras en {0}',
                time_of_day_range: 'entre {0} y {1}',
                points_earned_range: 'cuando gastas entre {0} y {1} puntos',
                transaction_total_range: 'cuando gastas entre ${0} y ${1}',
                earning_prefix_multiplication: 'gana x{0} puntos',
            },
            week_days: {
                0: 'domingos',
                1: 'lunes',
                2: 'martes',
                3: 'miércoles',
                4: 'jueves',
                5: 'viernes',
                6: 'sábados',
            },
            locations: {
                instore: 'en tienda',
                ecommerce_delivery: 'a través de entrega e-commerce',
                ecommerce_pickup: 'a través de recolección e-commerce',
                ecommerce: 'a través de e-commerce',
            },
        },
    },
};
export default lang;
